import SvgLogo265 from "src/Logo";
// import useWindowScrollPositions from "src/hooks/useScrollPosition";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import SvgCheck12 from "src/icons/Check12";

const PricingFormHeader = () => {
  // const scrollPosition = useWindowScrollPositions();
  return (
    <div
      className={clsx(
        "whitespace-nowrap flex justify-center xl:justify-start xl:flex-row w-full nav-bar z-dropdown xl:px-[9%] 2xl:px-[18%] h-[90px] fixed bg-lraidark border-b-8 border-lraiorange"
      )}
    >
      <div className="cursor-pointer self-center">
        {/* <Link ref="/" to={"https://wwww.livereach.ai"}> */}
        <SvgLogo265 color="#fff" />
        {/* </Link> */}
      </div>
    </div>
  );
};

const proposalLink = (retention: number, term: number, price: number) => {
  const params = {
    storageRetention: (() => {
      switch (retention) {
        case 30:
          return "30 Days";
        case 45:
          return "45 Days";
        case 60:
          return "60 Days";
        case 90:
          return "90 Days";
        case 120:
          return "120 Days";
        case 150:
          return "150 Days";
        case 180:
          return "180 Days";
      }
    })(),
    licenseTerm: (() => {
      switch (term) {
        case 12:
          return "12 Month";
        case 24:
          return "24 Month";
        case 36:
          return "36 Month";
        case 60:
          return "60 Month";
        case 120:
          return "120 Month";
      }
    })(),
    totalAmount: price,
  };
  const u = new URL(" https://form.jotform.com/251135979487068");
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      u.searchParams.set(key, value.toString());
    }
  }
  return u.toString();
};

const PricingForm = () => {
  const [cameras, setCameras] = useState<number>(12);
  const [duration, setDuration] = useState<number>(0);
  const [warranty, setWarranty] = useState<number>(0);
  const [price, setPrice] = useState<number>(0);
  const [monthlyPrice, setMonthlyPrice] = useState<number>(0);
  const [showPrice, setShowPrice] = useState<boolean>(false);
  const [licenses, setLicenses] = useState<number>(0);
  const [storage, setStorage] = useState<number>(0);
  const [term, setTerm] = useState<number>(0);
  const [industry, setIndustry] = useState<string>();

  const priceSectionRef = useRef<HTMLDivElement>(null);

  const calculatePrice = () => {
    const softwareMonthlyLicense = 10;
    const fixedInterestRate = 0.15;
    let hardwareCost = 0;
    // let hardwareType = "";
    if (cameras >= 1 && cameras <= 32) {
      hardwareCost = 4500;
      // hardwareType = "Standard Server";
    } else if (cameras >= 33 && cameras <= 64) {
      hardwareCost = 6500;
      // hardwareType = "Large Server";
    } else if (cameras >= 65 && cameras <= 80) {
      hardwareCost = 10500;
      // hardwareType = "Enterprise 2U Server";
    } else if (cameras > 80) {
      const bundles = Math.ceil(cameras / 80);
      hardwareCost = bundles * 10500; // Assuming each bundle costs $10,500
      // hardwareType = `${bundles}x Enterprise 2U Server Bundles`;
    }
    if (duration === 60) {
      hardwareCost += 3000; // Add $3,000 for 60 days
    } else if (duration === 90) {
      hardwareCost += 6000; // Add $6,000 for 90 days (cumulative)
    } else if (duration === 120) {
      hardwareCost += 9000; // Add $9,000 for 120 days
    } else if (duration === 150) {
      hardwareCost += 12000; // Add $12,000 for 150 days
    } else if (duration === 180) {
      hardwareCost += 15000; // Add $15,000 for 180 days
    }

    const softwareCost5Years = softwareMonthlyLicense * cameras * warranty;
    let totalPrice = softwareCost5Years + hardwareCost;
    if (warranty === 120) {
      // 10 Year License
      totalPrice = (softwareCost5Years + hardwareCost) * 1.75;
    }

    let discount = 0;

    switch (industry) {
      case "platinum":
        discount = 0.4;
        break;
      case "gold":
        discount = 0.1;
        break;
      default:
        discount = 0;
        break;
    }

    totalPrice *= 1 - discount;

    const adjustedTotal = totalPrice * (1 + fixedInterestRate);
    const monthlyPayment = adjustedTotal / warranty;

    setLicenses(cameras);
    setTerm(warranty);
    setStorage(duration);
    setMonthlyPrice(monthlyPayment);
    setPrice(adjustedTotal);
    setShowPrice(true);

    if (priceSectionRef.current) {
      priceSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  // Scroll to the price section when showPrice becomes true
  useEffect(() => {
    if (showPrice && priceSectionRef.current) {
      priceSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [showPrice]);

  return (
    <div className="w-full xl:w-screen h-full bg-white flex xl:overflow-x-hidden">
      <PricingFormHeader />
      <div className="py-10 px-4 md:px-6 xl:px-[9%] 2xl:px-[18%] mt-[90px] flex flex-col xl:flex-row h-full w-full justify-between gap-8 xl:gap-0">
        <div className="flex flex-col w-full xl:w-[500px]">
          <div className="text-3xl xl:text-4xl text-black text-center md:text-start font-bold">
            Build the camera system <br /> for your needs
          </div>
          <div className="flex flex-col py-6 border-b border-grey-200">
            <div className="flex flex-col xl:flex-col">
              <label
                htmlFor="cameras"
                className="text-base xl:text-lg text-lraidark w-full mb-2"
              >
                <span className="h-fit self-center">
                  Number of Camera Streams
                </span>
              </label>
              <div className="flex flex-col w-full">
                <input
                  type="number"
                  id="cameras"
                  placeholder="Input the number of camera streams"
                  className={clsx(
                    "bg-white border-2 text-base text-lraiorange flex items-center px-2 py-1 rounded-md focus:outline-none focus-visible:ring-0 border-lraiorange"
                  )}
                  value={cameras}
                  onChange={(e) => setCameras(parseInt(e.target.value))}
                />
                {/* <div className="text-right text-lraiorange"> cameras</span> */}
              </div>
            </div>
          </div>
          <div className="flex flex-col py-6 border-b border-grey-200">
            <div className="flex flex-col">
              <label
                htmlFor="storage"
                className="text-base xl:text-lg text-lraidark w-full mb-2"
              >
                <span className="h-fit self-center">
                  Select storage duration (in days)
                </span>
              </label>
              <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    duration === 30 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => duration !== 30 && setDuration(30)}
                >
                  30&nbsp;D&nbsp;
                  {duration === 30 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    duration === 60 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => duration !== 60 && setDuration(60)}
                >
                  60&nbsp;D&nbsp;
                  {duration === 60 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    duration === 90 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => duration !== 90 && setDuration(90)}
                >
                  90&nbsp;D&nbsp;
                  {duration === 90 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    duration === 120 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => duration !== 120 && setDuration(120)}
                >
                  120&nbsp;D&nbsp;
                  {duration === 120 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    duration === 150 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => duration !== 150 && setDuration(150)}
                >
                  150&nbsp;D&nbsp;
                  {duration === 150 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    duration === 180 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => duration !== 180 && setDuration(180)}
                >
                  180&nbsp;D&nbsp;
                  {duration === 180 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col py-6 border-b border-grey-200">
            <div className="flex flex-col">
              <label
                htmlFor="warranty"
                className="text-base xl:text-lg text-lraidark w-full mb-2"
              >
                <span className="h-fit self-center">
                  License & Warranty Term (in months)
                </span>
              </label>
              <div className="grid grid-cols-4 gap-2">
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    warranty === 24 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => warranty !== 24 && setWarranty(24)}
                >
                  24&nbsp;M&nbsp;
                  {warranty === 24 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    warranty === 36 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => warranty !== 36 && setWarranty(36)}
                >
                  36&nbsp;M&nbsp;
                  {warranty === 36 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    warranty === 60 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => warranty !== 60 && setWarranty(60)}
                >
                  60&nbsp;M&nbsp;
                  {warranty === 60 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
                <div
                  className={clsx(
                    "border border-lraiorange text-lraiorange rounded-lg cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                    warranty === 120 ? "bg-lraiorangeselected" : "bg-white"
                  )}
                  onClick={() => warranty !== 120 && setWarranty(120)}
                >
                  120&nbsp;M&nbsp;
                  {warranty === 120 ? <SvgCheck12 color="lraiorange" className="shrink-0" /> : <></>}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col py-6 border-b border-grey-200">
            <div className="flex flex-col">
              <label
                htmlFor="industry"
                className="text-base xl:text-lg text-lraidark w-full mb-2"
              >
                <span className="h-fit self-center">Select the Industry Pricing Tier</span>
              </label>
              <div className="flex flex-col gap-2 w-full">
                <div className="grid grid-cols-3 gap-2">
                  <div
                    className={clsx(
                      "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                      industry === "msrp"
                        ? "bg-lraiorangeselected"
                        : "bg-white"
                    )}
                    onClick={() =>
                      industry !== "msrp" && setIndustry("msrp")
                    }
                  >
                    MSRP&nbsp;
                    {industry === "msrp" ? (
                      <SvgCheck12 color="lraiorange" className="shrink-0" />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={clsx(
                      "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                      industry === "gold"
                        ? "bg-lraiorangeselected"
                        : "bg-white"
                    )}
                    onClick={() =>
                      industry !== "gold" && setIndustry("gold")
                    }
                  >
                    Gold&nbsp;
                    {industry === "gold" ? (
                      <SvgCheck12 color="lraiorange" className="shrink-0" />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={clsx(
                      "border border-lraiorange text-lraiorange rounded-lg p-3 cursor-pointer h-12 text-sm xl:text-base font-semibold text-center items-center flex flex-row justify-center",
                      industry === "platinum"
                        ? "bg-lraiorangeselected"
                        : "bg-white"
                    )}
                    onClick={() =>
                      industry !== "platinum" && setIndustry("platinum")
                    }
                  >
                    Platinum&nbsp;
                    {industry === "platinum" ? (
                      <SvgCheck12 color="lraiorange" className="shrink-0" />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="mt-6 button-gradient-background-no-hover h-[60px] content-center text-center text-white w-full rounded-md"
            onClick={calculatePrice}
            disabled={warranty === 0 || duration === 0 || cameras <= 0}
          >
            Check Price
          </button>
        </div>
        <div className="flex w-full xl:w-1/2" ref={priceSectionRef}>
          {showPrice && (
            <div className="gradient-orange-background w-full xl:w-[600px] rounded-2xl border border-white flex flex-col p-6 xl:p-10 justify-between">
              <div className="flex flex-col gap-3 text-center mt-4 mb-10">
                  <div className="flex flex-col text-white text-3xl xl:text-4xl font-semibold">
                    {licenses} Camera System with
                  </div>
                  <div className="flex flex-col text-white text-3xl xl:text-4xl font-semibold">
                    {storage} Day Storage Retention
                  </div>
              </div>
              <div className="border border-white rounded-lg flex flex-col gap-6 p-6 text-center">
                <div className="text-white text-lg xl:text-2xl">
                  {term} month License & Warranty Term at
                </div>
                <div className="flex flex-col gap-6">
                  <div className="text-white text-3xl xl:text-5xl font-bold">
                    ${Intl.NumberFormat().format(Number(price.toFixed(2)))}
                  </div>
                  <div className="text-white text-lg xl:text-2xl">or</div>
                  <div className="text-white text-3xl xl:text-5xl font-bold">
                    $
                    {Intl.NumberFormat().format(
                      Number(monthlyPrice.toFixed(2))
                    )}
                    /month
                  </div>
                </div>
                <div className="text-white text-base xl:text-lg">
                  (excludes interest fees if financing is selected)
                </div>
              </div>
              <a
                className="mt-6 h-[60px] content-center text-center text-lraiorange font-bold text-xl w-full rounded-md border border-white bg-white"
                href={proposalLink(storage, term, Number(price.toFixed(2)))}
                target="_blank"
                rel="noreferrer"
              >
                Purchase
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingForm;
